import React, { Suspense } from 'react';
import { ThemeProvider } from '@mui/material/styles';

import theme from './ui/theme.js';

// ROUTER

import AppRouter from './AppRouter.js';

// CONTEXT

import { AuthProvider } from './Context/AuthContext.js';

import { LocalizationProvider } from './Context/LocalizationContext.js';

import { ActingAsProvider } from './Context/ActingAsContext.js';

// COMPONENTS

import Loader from './Components/Loader/Loader.js';

import NotificationContainer from './Components/Notification2/NotificationContainer.js';

import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary.js';

// STYLING

import './App.css';


//

function App() {

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
      <div className="App">
        <LocalizationProvider>
          <AuthProvider>
            <ActingAsProvider>
              <Suspense fallback={<Loader />}>
                <AppRouter />
              </Suspense>
            </ActingAsProvider>
          </AuthProvider>
        </LocalizationProvider>
        <NotificationContainer />
      </div>
      </ThemeProvider>
    </ErrorBoundary>
  );

}

export default App;